import {Typography} from '@material-ui/core';
import {FC} from 'react';
import {observer} from 'mobx-react-lite';
import {useCombinationQuote} from './useCombinationQuote';
import {QuoteHistoryData} from '../../Core/mobx/ParameterStore/types';

interface QuoteCombinationInfoProps {
    singleQuote: QuoteHistoryData | null;
    combinedQuote: QuoteHistoryData | null;
}

export const QuoteCombinationInfo: FC<QuoteCombinationInfoProps> = observer(({singleQuote, combinedQuote}) => {
    const lastQuote = singleQuote;
    const lastCombinationQuote = combinedQuote;

    const [
        {
            singleQuoteProductType,
            combinedQuoteProductType,
            termPeriod,
            coverage,
            lifeCoverage,
            lifePremium,
            monthlyPremium,
        },
    ] = useCombinationQuote(lastQuote, lastCombinationQuote);

    const checkCombination = (first: string, second: string) => {
        return (
            (singleQuoteProductType === first && combinedQuoteProductType === second) ||
            (singleQuoteProductType === second && combinedQuoteProductType === first)
        );
    };

    const first = checkCombination('Term', 'IUL');
    const second = checkCombination('Term', 'GUL');
    const third = checkCombination('IUL', 'GUL');

    return (
        <>
            {first && (
                <>
                    <Typography variant="subtitle1" style={{textAlign: 'left'}}>
                        {`Year 1 - ${termPeriod} coverage: $${coverage.toLocaleString()}`}
                    </Typography>
                    <Typography variant="subtitle1" style={{textAlign: 'left'}}>
                        {`Year ${termPeriod} - life coverage: $${lifeCoverage.toLocaleString()}`}
                    </Typography>
                    <Typography variant="subtitle1" style={{textAlign: 'left'}}>
                        {`Year 1 - ${termPeriod} premium: $${monthlyPremium.toLocaleString()}`}
                    </Typography>
                    <Typography variant="subtitle1" style={{textAlign: 'left'}}>
                        {`Year ${termPeriod} - life premium: $${lifePremium.toLocaleString()}`}
                    </Typography>
                </>
            )}
            {second && (
                <>
                    <Typography variant="subtitle1" style={{textAlign: 'left'}}>
                        {`Year 1 - ${termPeriod} coverage: $${coverage.toLocaleString()}`}
                    </Typography>
                    <Typography variant="subtitle1" style={{textAlign: 'left'}}>
                        {`Year ${termPeriod} - life coverage: $${lifeCoverage}`}
                    </Typography>
                    <Typography variant="subtitle1" style={{textAlign: 'left'}}>
                        {`Year 1 - ${termPeriod} premium: $${monthlyPremium.toLocaleString()}`}
                    </Typography>
                    <Typography variant="subtitle1" style={{textAlign: 'left'}}>
                        {`Year ${termPeriod} - life premium: $${lifePremium.toLocaleString()}`}
                    </Typography>
                </>
            )}
            {third && (
                <>
                    <Typography variant="subtitle1" style={{textAlign: 'left'}}>
                        {`Combined coverage: $${coverage.toLocaleString()}`}
                    </Typography>
                    <Typography variant="subtitle1" style={{textAlign: 'left'}}>
                        {`Combined premium: $${lifePremium.toLocaleString()}`}
                    </Typography>
                </>
            )}
        </>
    );
});
